/* Globe Pickup Points widget — localized label override.
   Globe loads English fallback strings ("Home delivery", "Pickup points",
   "Change", "Choose delivery method") regardless of the storefront locale.
   This patch replaces the rendered text nodes after the widget mounts, picking
   the map for the active locale (Czech / Russian). For en/de we leave Globe's
   own labels untouched. Refresh the maps if the app DOM changes upstream. */
(function () {
  if (window.__globeI18nPatch) return;
  window.__globeI18nPatch = true;

  var MAPS = {
    cs: {
      'Choose delivery method': 'Vyberte způsob doručení',
      'Home delivery': 'Doručení domů',
      'Pickup points': 'Výdejní místa',
      'Change': 'Změnit',
      'Select pickup point': 'Vybrat výdejní místo',
      'Selected pickup point': 'Zvolené výdejní místo',
      'Search by city, ZIP or address': 'Vyhledejte město, PSČ nebo adresu',
      'Filter': 'Filtr',
      'Close': 'Zavřít',
      'Back to list': 'Zpět na seznam',
      'No results': 'Žádné výsledky'
    },
    ru: {
      'Choose delivery method': 'Выберите способ доставки',
      'Home delivery': 'Доставка на дом',
      'Pickup points': 'Пункты выдачи',
      'Change': 'Изменить',
      'Select pickup point': 'Выбрать пункт выдачи',
      'Selected pickup point': 'Выбранный пункт выдачи',
      'Search by city, ZIP or address': 'Поиск по городу, индексу или адресу',
      'Filter': 'Фильтр',
      'Close': 'Закрыть',
      'Back to list': 'Назад к списку',
      'No results': 'Нет результатов'
    }
  };

  var locale = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var TRANSLATIONS = MAPS[locale];
  if (!TRANSLATIONS) return;

  var ROOT_SELECTOR = '[id^="globe-"], [class^="globe-"], [class*=" globe-"]';
  var CONTROL_SELECTOR = 'button, label, option, h1, h2, h3, h4, h5, h6, [role="button"], [role="heading"], [role="tab"]';
  var EXCLUDED_SELECTOR = 'script, style, textarea, input, [contenteditable]:not([contenteditable="false"]), .jdgm-widget, .jdgm-review-widget, .jdgm-rev-widg, .jdgm-form-wrapper, .jm-review-widget, [data-template*="judgeme"]';
  var observedRoots = new WeakSet();
  var started = false;
  var cartOpenRequested = false;

  function translateNode(textNode, root) {
    // Most mutations contain product/review text or our own translated labels.
    // Reject those before walking ancestors for the application boundaries.
    var val = textNode.nodeValue;
    if (!val) return;
    var trimmed = val.trim();
    if (!Object.prototype.hasOwnProperty.call(TRANSLATIONS, trimmed)) return;
    var parent = textNode.parentElement;
    if (!parent || !root.contains(parent) || parent.closest(EXCLUDED_SELECTOR)) return;
    var control = parent.closest(CONTROL_SELECTOR);
    if (!control || !root.contains(control)) return;
    if (parent.closest('.shopify-app-block') !== root.closest('.shopify-app-block')) return;
    textNode.nodeValue = val.replace(trimmed, TRANSLATIONS[trimmed]);
  }

  function translateTree(node, root) {
    if (!node || !node.nodeType) return;
    if (node.nodeType === 3) { translateNode(node, root); return; }
    if (node.nodeType !== 1) return;
    try {
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
      var text;
      while ((text = walker.nextNode())) translateNode(text, root);
    } catch (e) {}
  }

  function observeRoot(root) {
    if (observedRoots.has(root) || root.closest(EXCLUDED_SELECTOR)) return;
    if (root.parentElement && root.parentElement.closest(ROOT_SELECTOR)) return;
    observedRoots.add(root);
    translateTree(root, root);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') translateNode(mutation.target, root);
        else mutation.addedNodes.forEach(function (node) { translateTree(node, root); });
      });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function discoverRoots(node) {
    if (node.nodeType !== 1 || !node.isConnected || node.closest(EXCLUDED_SELECTOR)) return;
    if (node.matches(ROOT_SELECTOR)) { observeRoot(node); return; }
    if (!node.childElementCount) return;
    node.querySelectorAll(ROOT_SELECTOR).forEach(observeRoot);
  }

  function start() {
    if (started || !document.body) return;
    started = true;
    document.removeEventListener('kvs:overlay-open', onCartOpen);
    document.removeEventListener('DOMContentLoaded', ready);
    document.removeEventListener('shopify:section:load', ready);
    discoverRoots(document.body);
    new MutationObserver(function (mutations) {
      var added = new Set();
      var eligibleTargets = new Map();
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes.length || mutation.target.nodeType !== 1) return;
        var elements = Array.from(mutation.addedNodes).filter(function (node) {
          return node.nodeType === 1 && node.isConnected;
        });
        if (!elements.length) return;
        var eligible = eligibleTargets.get(mutation.target);
        if (eligible === undefined) {
          eligible = !mutation.target.closest(ROOT_SELECTOR) && !mutation.target.closest(EXCLUDED_SELECTOR);
          eligibleTargets.set(mutation.target, eligible);
        }
        if (eligible) elements.forEach(function (node) { added.add(node); });
      });
      added.forEach(function (node) {
        // A framework can mount a parent and many descendants in one batch.
        // Discover the outer subtree once, retaining support for late portals.
        var parent = node.parentElement;
        while (parent) {
          if (added.has(parent)) return;
          parent = parent.parentElement;
        }
        discoverRoots(node);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function normalizedPath(value) {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return '';
    }
  }

  function onCartOpen(event) {
    var source = event.detail && event.detail.source;
    if (!source || !source.matches || !source.matches('cart-drawer')) return;
    cartOpenRequested = true;
    start();
  }

  function ready() {
    if (!document.body) return;
    var cartUrl = window.routes && window.routes.cart_url;
    if (!cartUrl) cartUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
    if (cartOpenRequested || normalizedPath(window.location.href) === normalizedPath(cartUrl) ||
        document.querySelector('cart-drawer.active')) start();
  }

  document.addEventListener('kvs:overlay-open', onCartOpen);
  document.addEventListener('shopify:section:load', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  ready();
})();
